// extracted by mini-css-extract-plugin
export default {"button":"jS8bbgKKFKE54kFK9X9Q"};